import { api } from '../config/api';

export const customerOrderService = {
  getAll: async (params = {}) => {
    const qp = new URLSearchParams();
    if (params.search) qp.append('search', params.search);
    if (params.status) qp.append('status', params.status);
    if (params.client_id) qp.append('client_id', params.client_id);
    const qs = qp.toString();
    return await api.get(`/customer-orders${qs ? `?${qs}` : ''}`);
  },

  getById: async (id) => {
    return await api.get(`/customer-orders/${id}/`);
  },

  create: async (data) => {
    return await api.post('/customer-orders/', data);
  },

  update: async (id, data) => {
    return await api.patch(`/customer-orders/${id}/`, data);
  },

  delete: async (id) => {
    return await api.delete(`/customer-orders/${id}/`);
  },

  generateFullOrder: async (id) => {
    return await api.post(`/customer-orders/${id}/generate-full-order/`);
  },

  generateFromProposal: async (proposalId) => {
    return await api.post(`/customer-orders/from-proposal/${proposalId}/`);
  },

  getChoices: async () => {
    return await api.get('/customer-orders/choices/');
  },

  getContainerSpecs: async () => {
    return await api.get('/customer-orders/container-specs/');
  },

  getItems: async (orderId) => {
    return await api.get(`/customer-orders/${orderId}/items/`);
  },

  createItem: async (orderId, data) => {
    return await api.post(`/customer-orders/${orderId}/items/`, data);
  },

  updateItem: async (orderId, itemId, data) => {
    return await api.patch(`/customer-orders/${orderId}/items/${itemId}/`, data);
  },

  deleteItem: async (orderId, itemId) => {
    return await api.delete(`/customer-orders/${orderId}/items/${itemId}/`);
  },
};
